<template>
  <app-navigation></app-navigation>
</template>

<script>

import Navigation from '@/components/Base/Navigation'

export default {
  components: {
    'app-navigation': Navigation
  },
  data () {
    return {
    }
  }
}
</script>

<style>
  .card-rounded {
    border-radius: 8px !important;
  }


  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 5px
  }  
</style>




// WEBPACK FOOTER //
// src/components/Base/Home.vue